window.inactivity_cnt=new Date().getTime();

window.inactivity_check = function(){
    
//    if(typeof user_data === 'undefined'){
//        //console.log('notlogged');
//        return;
//    }
        
    
    //console.log('IC');
    
    var cts=new Date().getTime();
    
//    alert(cts+'/'+window.inactivity_cnt);
//    alert(cts-window.inactivity_cnt);
    if(cts-window.inactivity_cnt>1150*1000){
//    if(window.inactivity_cnt>550){
//    if(window.inactivity_cnt>10){
        //alert('reload');
        //location.reload(); 
        
        var refresh_url = window.location.href+'#';
        refresh_url=refresh_url.split('#')[0];
        
        window.location = refresh_url;
        
    }else{
        //reset counter...
        //window.inactivity_cnt=0;
        window.inactivity_cnt=new Date().getTime();
    }
};

window.document.addEventListener('keypress', window.inactivity_check);
window.document.addEventListener('mousedown', window.inactivity_check);


//setInterval(function(){
//   window.inactivity_cnt+=5; 
//   console.log('cnt: '+window.inactivity_cnt);
//},5000);

window.chartColors = {
    red: 'rgb(255, 99, 132)',
    orange: 'rgb(255, 159, 64)',
    yellow: 'rgb(255, 205, 86)',
    green: 'rgb(75, 192, 192)',
    blue: 'rgb(54, 162, 235)',
    purple: 'rgb(153, 102, 255)',
    grey: 'rgb(201, 203, 207)'
};


window.db_to_yyyy_mm_dd_date = function (date){
    
    if(!date){
        return '';
    }
    
    var d=new Date(date);
                            
    var dd = d.getDate();

    var mm = d.getMonth()+1; 
    var yyyy = d.getFullYear();
    if(dd<10){
        dd='0'+dd;
    } 
    if(mm<10){
        mm='0'+mm;
    } 

    return yyyy+'-'+mm+'-'+dd;
    
};
window.db_to_local_date = function (date){
    
    if(!date){
        return '';
    }
    
    if(date.indexOf('-')==-1){
        //YYYYMMDD=>YYYY-MM-DD
        var new_date=date.substr(0,4)+"-"+date.substr(4,2)+"-"+date.substr(6,2);
        date=new_date;
    }
    
    var d=new Date(date);
    
    
    var dd = d.getDate();

    var mm = d.getMonth()+1; 
    var yyyy = d.getFullYear();
    if(dd<10){
        dd='0'+dd;
    } 
    if(mm<10){
        mm='0'+mm;
    } 

    return dd+'.'+mm+'.'+yyyy+'.';
    //return dd+'.'+mm+'.'+yyyy+'.'+'('+date+')';
};
window.db_to_local_datetime = function (datetime){
    
    if(!datetime){
        return '';
    }
    
    datetime=datetime.replace('Z','');
    //datetime=datetime.replace('T',' ');

    // console.log(datetime);

    var d=new Date(datetime);
                            
    var dd = d.getDate();

    var mm = d.getMonth()+1; 
    var yyyy = d.getFullYear();
    var hh=d.getHours();
    var ii=d.getMinutes();
    var ss=d.getSeconds();
    if(dd<10){
        dd='0'+dd;
    } 
    if(mm<10){
        mm='0'+mm;
    } 
    if(hh<10){
        hh='0'+hh;
    } 
    if(ii<10){
        ii='0'+ii;
    } 
    if(ss<10){
        ss='0'+ss;
    } 



    return dd+'.'+mm+'.'+yyyy+'. '+hh+':'+ii+':'+ss;
    //return dd+'.'+mm+'.'+yyyy+'. '+hh+':'+ii+':'+ss+'('+datetime+')';
};

window.format_currency = function(amount, decimalCount = 2, decimal = ",", thousands = ".") {
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? "-" : "";

    let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
    let j = (i.length > 3) ? i.length % 3 : 0;

    return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
  } catch (e) {
    console.log(e);
  }
};

window.validate_server_response=function(response){
//    console.log(response);
//    console.log(response.status.success);
//    console.log(response.status.message);
//    console.log(response.status.error.message);
    if(!response.status.success || response.status.success=='error'){
        unblock_user_interface();
        if(response.status.redirect=='login'){
            $('#errorSessionModal').modal('show');
        }else{
            if(response.status.message){
                $('#errorModal .modal-body').html(response.status.message);
            }else{
                $('#errorModal .modal-body').html(response.status.error.message);
            }
            
            $('#errorModal').modal('show');

            $('#errorModal').on('hidden.bs.modal', function () {
                console.log('error modal hidden');
                if($('.modal').hasClass('show')){
                    $('body').addClass('modal-open');
                }

            });

        }
        return false;
    }
    
    window.inactivity_cnt=new Date().getTime();
    
    return true;
};

window.block_user_interface=function(){
    
    //var popupwidth = $(window).width() - 40;
    //var popupheight = $(window).height() - 100;
    //var top = 20;
    //var left = (width - popupwidth) / 2 ;
    
    if($('.blockUI').length){
        return;
    }
    
    $.blockUI({
        baseZ:10000,
//    $('body').block({
	message: '<i class="fa fa-database text-grey"></i>',
	// message: '<img src="/images/ajax-loader.gif" />',
    fadeIn:10,
	css: { 
            border: 'none', 
            padding: '15px', 
            backgroundColor: '#fff', 
            '-webkit-border-radius': '10px', 
            '-moz-border-radius': '10px', 
            opacity: .5, 
            color: '#000'
            
        } 
    });
};

window.unblock_user_interface=function(){
    $.unblockUI();
//    $('body').unblock(); 
};

